document.addEventListener("DOMContentLoaded", function () {
  const params = new URLSearchParams(window.location.search);
  const path = window.location.pathname;

  const isProductPage =
    /^\/products\/[^/]+\/?$/.test(path) ||
    /^\/collections\/[^/]+\/products\/[^/]+\/?$/.test(path);

  function hasRequiredTopBar() {
    return !!document.querySelector(
      ".top-bar.top-byor #back-button, .top-bar.top-byor #start-over"
    );
  }

  function applyCustomStyle() {
    if (document.getElementById("review-product-custom-style")) return;

    const style = document.createElement("style");
    style.id = "review-product-custom-style";
    style.innerHTML = `
      @media (min-width: 700px) {
        .steper-key {
          margin-left: 50px !important;
          width: 100% !important;
        }

        .page-width-key {
          width: 100% !important;
          padding: 0 !important;
        }
      }
    `;
    document.head.appendChild(style);
  }

  if (!isProductPage) return;

  const isReviewPage = params.has("review");

  if (isReviewPage || hasRequiredTopBar()) {
    applyCustomStyle();
    return;
  }

  const observer = new MutationObserver(function () {
    if (hasRequiredTopBar()) {
      applyCustomStyle();
      observer.disconnect();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});

let kirbFilterContainerObserved = false;
let kirbBannerObserverBound = false;
let kirbFacetHideTimer = null;

function kirbGetSlider(container) {
  const jewellerySlider = container.querySelector(".collection-fine-jewellery");

  if (
    jewellerySlider &&
    window.getComputedStyle(jewellerySlider).display !== "none"
  ) {
    return jewellerySlider;
  }

  return container.querySelector(".collection-ring");
}

function kirbSyncSliderAlignment(slider) {
  if (!slider) return;

  const hasOverflow = slider.scrollWidth > slider.clientWidth + 2;
  slider.classList.toggle("kirb-has-overflow", hasOverflow);

  if (!hasOverflow && slider.scrollLeft !== 0) {
    slider.scrollLeft = 0;
  }
}

function updateRingSliderArrows(slider, leftArrow, rightArrow) {
  if (!slider || !leftArrow || !rightArrow) return;

  const maxScroll = slider.scrollWidth - slider.clientWidth;
  const scrollPosition = slider.scrollLeft;
  const tolerance = 5;
  const hasOverflow = maxScroll > tolerance;

  if (!hasOverflow) {
    leftArrow.classList.add("arrow-hidden");
    leftArrow.classList.remove("arrow-visible");

    rightArrow.classList.add("arrow-hidden");
    rightArrow.classList.remove("arrow-visible");
    return;
  }

  if (scrollPosition <= tolerance) {
    leftArrow.classList.add("arrow-hidden");
    leftArrow.classList.remove("arrow-visible");
  } else {
    leftArrow.classList.remove("arrow-hidden");
    leftArrow.classList.add("arrow-visible");
  }

  if (scrollPosition >= maxScroll - tolerance) {
    rightArrow.classList.add("arrow-hidden");
    rightArrow.classList.remove("arrow-visible");
  } else {
    rightArrow.classList.remove("arrow-hidden");
    rightArrow.classList.add("arrow-visible");
  }
}

function sliderFun(slider) {
  if (!slider) return;

  const leftArrow = slider.querySelector(
    ".ring-left-arrow, .ring-left-arrow-fine-jewellery"
  );

  const rightArrow = slider.querySelector(
    ".ring-right-arrow, .ring-right-arrow-fine-jewellery"
  );

  if (!leftArrow || !rightArrow) return;

  const sliderWrap = slider.closest(".kirb-inner-ring-filter");

  if (sliderWrap) {
    sliderWrap.querySelectorAll(".kirb-ring-arrow").forEach(arrow => {
      if (arrow !== leftArrow && arrow !== rightArrow) {
        arrow.classList.add("arrow-hidden");
        arrow.classList.remove("arrow-visible");
      }
    });
  }

  kirbSyncSliderAlignment(slider);
  updateRingSliderArrows(slider, leftArrow, rightArrow);

  if (slider.dataset.kirbSliderBound === "true") return;
  slider.dataset.kirbSliderBound = "true";

  let isDown = false;
  let startX = 0;
  let scrollLeft = 0;

  slider.addEventListener("scroll", () => {
    updateRingSliderArrows(slider, leftArrow, rightArrow);
  });

  window.addEventListener("resize", () => {
    kirbSyncSliderAlignment(slider);
    updateRingSliderArrows(slider, leftArrow, rightArrow);
  });

  slider.addEventListener("mousedown", e => {
    isDown = true;
    slider.classList.add("active");
    startX = e.pageX - slider.offsetLeft;
    scrollLeft = slider.scrollLeft;
  });

  slider.addEventListener("mouseleave", () => {
    isDown = false;
    slider.classList.remove("active");
  });

  slider.addEventListener("mouseup", () => {
    isDown = false;
    slider.classList.remove("active");
  });

  slider.addEventListener("mousemove", e => {
    if (!isDown) return;

    e.preventDefault();
    const x = e.pageX - slider.offsetLeft;
    const walk = (x - startX) * 3;
    slider.scrollLeft = scrollLeft - walk;
  });

  if (leftArrow.dataset.kirbArrowBound !== "true") {
    leftArrow.dataset.kirbArrowBound = "true";
    leftArrow.addEventListener("click", () => {
      slider.scrollTo({
        left: 0,
        behavior: "smooth"
      });
    });
  }

  if (rightArrow.dataset.kirbArrowBound !== "true") {
    rightArrow.dataset.kirbArrowBound = "true";
    rightArrow.addEventListener("click", () => {
      slider.scrollTo({
        left: slider.scrollWidth - slider.clientWidth,
        behavior: "smooth"
      });
    });
  }

  requestAnimationFrame(() => {
    kirbSyncSliderAlignment(slider);
    updateRingSliderArrows(slider, leftArrow, rightArrow);
  });
}

function kirbInitCollections() {
  document.querySelectorAll(".filters-containers[collection_handle]").forEach(container => {
    const slider = kirbGetSlider(container);
    sliderFun(slider);
  });
}

function kirbObserveFilterContainers() {
  if (kirbFilterContainerObserved) return;

  const appMainBlock = document.querySelector(".app-main-block");
  if (!appMainBlock) return;

  kirbFilterContainerObserved = true;

  const observer = new MutationObserver(mutationsList => {
    const hasAddedNodes = mutationsList.some(
      mutation => mutation.addedNodes.length > 0
    );

    if (hasAddedNodes) {
      kirbInitCollections();
      kirbScheduleFacetHide();
    }
  });

  observer.observe(appMainBlock, {
    childList: true,
    subtree: true
  });
}

function kirbEnsureFacetHideStyle() {
  if (document.getElementById("kirb-hide-facets-style")) return;

  const style = document.createElement("style");
  style.id = "kirb-hide-facets-style";
  style.textContent = `
    html[data-kirb-hide-facets="true"] .facets--bar,
    .facets--bar.kirb-force-hide {
      display: none !important;
      visibility: hidden !important;
      opacity: 0 !important;
      pointer-events: none !important;
    }
  `;
  document.head.appendChild(style);
}

function kirbShouldHideFacets() {
  return !!document.querySelector(
    ".app-main-block .app2-filter-bar, .open-filter-btn-section .app2-filter-bar"
  );
}

function kirbToggleMainCollectionBanner() {
  kirbEnsureFacetHideStyle();

  const shouldHideFacets = kirbShouldHideFacets();

  document.documentElement.setAttribute(
    "data-kirb-hide-facets",
    shouldHideFacets ? "true" : "false"
  );

  document.querySelectorAll(".facets--bar").forEach(facetBar => {
    facetBar.classList.toggle("kirb-force-hide", shouldHideFacets);

    if (shouldHideFacets) {
      facetBar.setAttribute("aria-hidden", "true");
      facetBar.style.setProperty("display", "none", "important");
    } else {
      facetBar.removeAttribute("aria-hidden");
      facetBar.style.removeProperty("display");
    }
  });
}

function kirbScheduleFacetHide() {
  clearTimeout(kirbFacetHideTimer);

  kirbFacetHideTimer = setTimeout(() => {
    kirbToggleMainCollectionBanner();

    requestAnimationFrame(() => {
      kirbToggleMainCollectionBanner();
    });

    setTimeout(() => {
      kirbToggleMainCollectionBanner();
    }, 120);
  }, 0);
}

function kirbInitBannerVisibility() {
  if (kirbBannerObserverBound) return;
  kirbBannerObserverBound = true;

  kirbEnsureFacetHideStyle();
  kirbToggleMainCollectionBanner();

  const observer = new MutationObserver(() => {
    kirbScheduleFacetHide();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  document.addEventListener(
    "click",
    function (e) {
      const filterTrigger = e.target.closest(
        ".app2-filter-bar, .facets--bar, .custom-filter, .kirb-ring-item, .kirb-metal-item, input, label, select, button"
      );

      if (filterTrigger) {
        kirbScheduleFacetHide();
      }
    },
    true
  );
}

function kirbInit() {
  kirbInitCollections();
  kirbObserveFilterContainers();
  kirbInitBannerVisibility();

  window.addEventListener("popstate", () => {
    setTimeout(() => {
      kirbInitCollections();
      kirbToggleMainCollectionBanner();
    }, 0);
  });

  requestAnimationFrame(() => {
    kirbToggleMainCollectionBanner();
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", kirbInit);
} else {
  kirbInit();
}


(function () {
  const KIRB_BYOR_STYLE_ID = "kirb-byor-rect-strip-style";
  const KIRB_SCAN_INTERVAL = 700;

  function kirbInjectByorRectStyle() {
    if (document.getElementById(KIRB_BYOR_STYLE_ID)) return;

    const style = document.createElement("style");
    style.id = KIRB_BYOR_STYLE_ID;
    style.textContent = `
    @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400&family=Sorts+Mill+Goudy:ital@0;1&display=swap');

    .key-ideas-app .main-byor-section .byor-head-1 {
      display: none !important;
    }

    .key-ideas-app .main-byor-section .byor-head-2 {
      display: flex !important;
      align-items: stretch !important;
      justify-content: stretch !important;
      width: 100% !important;
      border-top: 1px solid #e9e9e9 !important;
      border-bottom: 1px solid #e9e9e9 !important;
      background: #fff !important;
      gap: 0 !important;
      margin: 0 !important;
      padding: 0 !important;
    }

    .key-ideas-app .main-byor-section .byor-head-2 > .item-byor {
      flex: 1 1 0 !important;
      min-width: 0 !important;
      margin: 0 !important;
      padding: 14px 18px !important;
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      position: relative !important;
      color: #b6b6b6 !important;
      background: #fff !important;
      box-sizing: border-box !important;
      cursor: pointer !important;
    }

    .key-ideas-app .main-byor-section .byor-head-2 > .item-byor:not(:last-child)::after {
      content: "" !important;
      position: absolute !important;
      top: 10px !important;
      right: 0 !important;
      width: 1px !important;
      height: calc(100% - 20px) !important;
      background: #ececec !important;
    }

    .main-byor-section .new-byor-section .item-byor .number-head {
        display: flex !important;
        align-items: flex-end !important;
        font-size: 26px;
        background-color: transparent !important;
    }

    .key-ideas-app .main-byor-section.kirb-rtl .byor-head-2 > .item-byor:not(:last-child)::after {
      right: auto !important;
      left: 0 !important;
    }

    .key-ideas-app .main-byor-section .byor-head-2 .byor-number {
      width: auto !important;
      max-width: 100% !important;
      margin: 0 auto !important;
      display: inline-flex !important;
      align-items: center !important;
      justify-content: center !important;
    }

    .key-ideas-app .main-byor-section .kirb-byor-strip-inner {
      width: auto !important;
      max-width: 100% !important;
      display: inline-flex !important;
      align-items: center !important;
      justify-content: center !important;
      gap: 10px !important;
      white-space: nowrap !important;
    }

    .key-ideas-app .main-byor-section.kirb-rtl .kirb-byor-strip-inner {
      flex-direction: row-reverse !important;
    }

    .key-ideas-app .main-byor-section .kirb-byor-step-label {
      display: inline-flex !important;
      align-items: center !important;
      justify-content: center !important;
      gap: 4px !important;
      min-width: 0 !important;
      max-width: 100% !important;
      line-height: 1.2 !important;
      text-transform: none !important;
      letter-spacing: normal !important;
    }

    .key-ideas-app .main-byor-section .kirb-byor-step-number,
    .key-ideas-app .main-byor-section .kirb-byor-step-number .number-dot {
      display: inline-flex !important;
      align-items: center !important;
      flex: 0 0 auto !important;
      font-family: 'Playfair Display', serif !important;
      font-weight: 400 !important;
      font-style: normal !important;
      color: inherit !important;
      text-transform: none !important;
      letter-spacing: normal !important;
    }

    .key-ideas-app .main-byor-section .kirb-byor-step-text {
      display: flex;
      min-width: 0 !important;
      color: inherit !important;
      overflow: hidden !important;
      text-overflow: ellipsis !important;
      font-family: 'Sorts Mill Goudy', serif !important;
      font-weight: 400 !important;
      font-size: 12px;
      font-style: normal !important;
      text-transform: uppercase !important;
      letter-spacing: normal !important;
      align-content: flex-end;
    }

    .key-ideas-app .main-byor-section .kirb-byor-step-text > span {
      color: inherit !important;
      margin-right: 4px !important;
      font-family: 'Sorts Mill Goudy', serif !important;
      font-weight: 400 !important;
      font-style: normal !important;
      text-transform: uppercase !important;
      letter-spacing: normal !important;
    }

    .key-ideas-app .main-byor-section.kirb-rtl .kirb-byor-step-text > span {
      margin-right: 0 !important;
      margin-left: 4px !important;
    }

    .key-ideas-app .main-byor-section .kirb-byor-step-icon {
      display: inline-flex !important;
      align-items: center !important;
      justify-content: center !important;
      flex: 0 0 auto !important;
      color: inherit !important;
    }

    .key-ideas-app .main-byor-section .kirb-byor-step-icon svg {
      display: block !important;
      width: 18px !important;
      height: 18px !important;
      max-width: 18px !important;
      max-height: 18px !important;
    }

    .key-ideas-app .main-byor-section .kirb-byor-step-icon svg [stroke] {
      stroke: currentColor !important;
    }

    .key-ideas-app .main-byor-section .kirb-byor-step-icon svg [fill]:not([fill="none"]) {
      fill: currentColor !important;
    }

    .key-ideas-app .main-byor-section .byor-head-2 > .item-byor.kirb-active {
      color: var(--app-normal-primary-color, #111) !important;
    }

    .key-ideas-app .main-byor-section .byor-head-2 > .item-byor.active:not(.kirb-active),
    .key-ideas-app .main-byor-section .byor-head-2 > .item-byor.current:not(.kirb-active),
    .key-ideas-app .main-byor-section .byor-head-2 > .item-byor.selected:not(.kirb-active),
    .key-ideas-app .main-byor-section .byor-head-2 > .item-byor.checked:not(.kirb-active),
    .key-ideas-app .main-byor-section .byor-head-2 > .item-byor.open:not(.kirb-active) {
      color: #b6b6b6 !important;
    }

    .key-ideas-app .main-byor-section .byor-head-2 > .item-byor.kirb-complete:not(.kirb-active) {
      color: #666 !important;
    }

    @media (max-width: 767px) {
      .key-ideas-app .main-byor-section .byor-head-2 > .item-byor {
        padding: 2px 8px !important;
      }

      .key-ideas-app .main-byor-section .kirb-byor-step-text{
        font-size: 7px;
      }

      .main-byor-section .new-byor-section .item-byor .number-head {
          font-size: 18px !important;
          width: 3px !important;
          height: 30px !important;
          align-items: flex-start !important;
      }

      .key-ideas-app .main-byor-section .kirb-byor-step-icon{
      width: 10px;}

      .main-byor-section .byor-detail-dropdown {
        margin-top: 5px !important;
      }

      .key-ideas-app .main-byor-section .kirb-byor-strip-inner {
        gap: 1px !important;
      }

      .key-ideas-app .main-byor-section .kirb-byor-step-label {
        font-size: 11px !important;
      }

      .key-ideas-app .main-byor-section .kirb-byor-step-icon svg {
        width: 15px !important;
        height: 15px !important;
        max-width: 15px !important;
        max-height: 15px !important;
      }
    }
  `;
    document.head.appendChild(style);
  }

  function kirbGetDirectItems(parent) {
    if (!parent) return [];
    return Array.from(parent.querySelectorAll(":scope > .item-byor"));
  }

  function kirbGetStepNumber(item) {
    const numberHead = item.querySelector(".number-head");
    if (!numberHead) return "";

    const clone = numberHead.cloneNode(true);
    clone.querySelectorAll(".number-dot").forEach((dot) => dot.remove());
    return clone.textContent.replace(/\s+/g, " ").trim();
  }

  function kirbGetStepTextHtml(item) {
    const choose = item.querySelector(".choose");
    return choose ? choose.innerHTML.trim() : "";
  }

  function kirbGetIconHtml(item) {
    const iconCircle = item.querySelector(".byor-icon-circle");
    return iconCircle ? iconCircle.innerHTML.trim() : "";
  }

  function kirbGetTooltipKey(item) {
    if (!item) return "";

    const hoverSource =
      item.dataset.kirbHoverSource ||
      item.getAttribute("onmouseover") ||
      item.getAttribute("onmouseenter") ||
      "";
    const tooltipMatch = hoverSource.match(/showTooltipbyor\(\s*['"]([^'"]+)['"]\s*\)/);

    return tooltipMatch ? tooltipMatch[1] : "";
  }

  function kirbClearByorHideTimer(section) {
    if (!section || !section._kirbByorHideTimer) return;

    clearTimeout(section._kirbByorHideTimer);
    section._kirbByorHideTimer = null;
  }

  function kirbShowByorTooltip(tooltipKey) {
    if (!tooltipKey || typeof window.showTooltipbyor !== "function") return;
    window.showTooltipbyor(tooltipKey);
  }

  function kirbHideByorTooltip() {
    if (typeof window.hideTooltipbyor !== "function") return;
    window.hideTooltipbyor();
  }

  function kirbScheduleByorHide(section, hoverTarget, tooltip) {
    if (!section) return;

    kirbClearByorHideTimer(section);
    section._kirbByorHideTimer = window.setTimeout(() => {
      const isHoverTargetActive = hoverTarget && hoverTarget.matches(":hover");
      const isTooltipActive = tooltip && tooltip.matches(":hover");

      if (!isHoverTargetActive && !isTooltipActive) {
        kirbHideByorTooltip();
      }
    }, 50);
  }

  function kirbBindByorHover(section) {
    if (!section) return;

    const head2 = section.querySelector(".byor-head-2");
    const head2Items = kirbGetDirectItems(head2);

    head2Items.forEach((item) => {
      const hoverTarget = item;

      if (!hoverTarget) return;

      const originalHoverSource = item.getAttribute("onmouseover");
      if (originalHoverSource && !item.dataset.kirbHoverSource) {
        item.dataset.kirbHoverSource = originalHoverSource;
      }
      item.removeAttribute("onmouseover");

      const tooltipKey = kirbGetTooltipKey(item);
      const tooltip = tooltipKey
        ? section.querySelector(`.tooltip-content-${tooltipKey}`)
        : null;

      if (hoverTarget.dataset.kirbHoverBound === "true") return;

      const handleEnter = () => {
        kirbClearByorHideTimer(section);
        kirbShowByorTooltip(tooltipKey);
      };
      const handleLeave = () => {
        kirbScheduleByorHide(section, hoverTarget, tooltip);
      };

      hoverTarget.addEventListener("mouseenter", handleEnter);
      hoverTarget.addEventListener("mouseleave", handleLeave);
      hoverTarget.addEventListener("focusin", handleEnter);
      hoverTarget.addEventListener("focusout", handleLeave);
      hoverTarget.dataset.kirbHoverBound = "true";

      if (tooltip && tooltip.dataset.kirbHoverBound !== "true") {
        tooltip.addEventListener("mouseenter", () => {
          kirbClearByorHideTimer(section);
        });
        tooltip.addEventListener("mouseleave", () => {
          kirbScheduleByorHide(section, hoverTarget, tooltip);
        });
        tooltip.dataset.kirbHoverBound = "true";
      }
    });
  }

  function kirbGetSectionSignature(section) {
    const head1 = section.querySelector(".byor-head-1");
    const head2 = section.querySelector(".byor-head-2");
    const head1Items = kirbGetDirectItems(head1);
    const head2Items = kirbGetDirectItems(head2);

    const parts = [];
    for (let i = 0; i < Math.max(head1Items.length, head2Items.length); i++) {
      parts.push(
        [
          kirbGetStepNumber(head2Items[i] || document.createElement("div")),
          kirbGetStepTextHtml(head2Items[i] || document.createElement("div")),
          kirbGetIconHtml(head1Items[i] || document.createElement("div"))
        ].join("||")
      );
    }
    return parts.join("###");
  }

  function kirbBuildRectStep(head2Item, iconHtml) {
    if (!head2Item) return;

    const byorNumber = head2Item.querySelector(".byor-number");
    if (!byorNumber) return;

    const stepNumber = kirbGetStepNumber(head2Item);
    const textHtml = kirbGetStepTextHtml(head2Item);

    const wrapper = document.createElement("div");
    wrapper.className = "kirb-byor-strip-inner kirb-byor-hit-area";

    const label = document.createElement("div");
    label.className = "kirb-byor-step-label";

    const number = document.createElement("span");
    number.className = "number-head kirb-byor-step-number";
    number.innerHTML = `${stepNumber}<span class="number-dot"></span>`;

    const text = document.createElement("span");
    text.className = "choose kirb-byor-step-text";
    text.innerHTML = textHtml;

    const icon = document.createElement("div");
    icon.className = "kirb-byor-step-icon";
    icon.innerHTML = iconHtml || "";

    label.appendChild(number);
    label.appendChild(text);
    wrapper.appendChild(label);
    wrapper.appendChild(icon);

    byorNumber.innerHTML = "";
    byorNumber.appendChild(wrapper);
  }

  function kirbHasAnyClass(node, classNames) {
    if (!node) return false;
    return classNames.some((cls) => node.classList.contains(cls));
  }

  function kirbGetActiveIndexFromExistingState(head1Items, head2Items) {
    const activeClasses = ["active", "current", "selected", "checked", "open"];

    for (let i = 0; i < head2Items.length; i++) {
      if (kirbHasAnyClass(head2Items[i], activeClasses) || kirbHasAnyClass(head1Items[i], activeClasses)) {
        return i;
      }
    }

    return -1;
  }

  function kirbGetStepIndexByKeyword(head2Items, pattern) {
    return head2Items.findIndex((item) =>
      pattern.test((item.querySelector(".choose")?.textContent || "").toLowerCase())
    );
  }

  function kirbDetectActiveIndexFromRoute(head2Items) {
    const routeSignals = [
      window.location.pathname,
      window.location.search
    ]
      .join(" ")
      .toLowerCase();

    if (/review|checkout|cart/.test(routeSignals)) {
      return kirbGetStepIndexByKeyword(head2Items, /(complete|checkout|check out|cart|review)/);
    }

    if (/engagement-ring-settings|engagement-rings-settings|ring-settings|settings/.test(routeSignals)) {
      return kirbGetStepIndexByKeyword(head2Items, /(setting|settings)/);
    }

    if (/lab-diamonds|natural-diamonds|colored-diamonds|diamond-details|loose-diamond|loose-diamonds/.test(routeSignals)) {
      return kirbGetStepIndexByKeyword(head2Items, /(diamond|diamonds|gem|gemstone|stone)/);
    }

    return -1;
  }

  function kirbApplyCompleteState(head1Items, head2Items) {
    const completeClasses = ["complete", "completed", "done", "visited"];

    head2Items.forEach((item, index) => {
      const isComplete =
        kirbHasAnyClass(item, completeClasses) ||
        kirbHasAnyClass(head1Items[index], completeClasses)
      ;

      item.classList.toggle("kirb-complete", isComplete);
    });
  }

  function kirbTextMatchesSignals(stepText, signals) {
    const text = stepText.toLowerCase();

    if (/(diamond|diamonds|gem|gemstone|stone)/.test(text)) {
      return /(diamond|diamonds|gem|gemstone|stone)/.test(signals);
    }

    if (/(setting|settings)/.test(text)) {
      return /(setting|settings|engagement-ring-settings|ring-settings)/.test(signals);
    }

    if (/(pendant|pendants)/.test(text)) {
      return /(pendant|pendants)/.test(signals);
    }

    if (/(earring|earrings|stud)/.test(text)) {
      return /(earring|earrings|stud)/.test(signals);
    }

    if (/(complete|checkout|check out|cart|review)/.test(text)) {
      return /(complete|checkout|check out|cart|review)/.test(signals);
    }

    return false;
  }

  function kirbDetectActiveIndexFromPage(head2Items) {
    const bodyClass = document.body ? document.body.className : "";
    const h1Text = document.querySelector("h1") ? document.querySelector("h1").textContent : "";
    const signals = [
      window.location.pathname,
      window.location.search,
      document.title,
      bodyClass,
      h1Text
    ]
      .join(" ")
      .toLowerCase();

    if (/review|checkout|cart/.test(signals)) {
      const finalIndex = head2Items.findIndex((item) =>
        /(complete|checkout|check out|cart|review)/.test(
          item.querySelector(".choose")?.textContent.toLowerCase() || ""
        )
      );
      if (finalIndex > -1) return finalIndex;
    }

    for (let i = 0; i < head2Items.length; i++) {
      const text = head2Items[i].querySelector(".choose")?.textContent || "";
      if (kirbTextMatchesSignals(text, signals)) {
        return i;
      }
    }

    return -1;
  }

  function kirbSyncActiveState(section) {
    const head1 = section.querySelector(".byor-head-1");
    const head2 = section.querySelector(".byor-head-2");
    const head1Items = kirbGetDirectItems(head1);
    const head2Items = kirbGetDirectItems(head2);

    if (!head2Items.length) return;

    kirbApplyCompleteState(head1Items, head2Items);

    let activeIndex = kirbDetectActiveIndexFromRoute(head2Items);
    if (activeIndex === -1) {
      activeIndex = kirbDetectActiveIndexFromPage(head2Items);
    }
    if (activeIndex === -1) {
      activeIndex = kirbGetActiveIndexFromExistingState(head1Items, head2Items);
    }
    if (activeIndex === -1) {
      activeIndex = 0;
    }

    head2Items.forEach((item, index) => {
      item.classList.toggle("kirb-active", index === activeIndex);
    });
  }

  function kirbBuildByorSection(section) {
    if (!section) return;

    const head1 = section.querySelector(".byor-head-1");
    const head2 = section.querySelector(".byor-head-2");
    if (!head1 || !head2) return;

    const currentSignature = kirbGetSectionSignature(section);
    const previousSignature = section.getAttribute("data-kirb-rect-signature");

    if (currentSignature !== previousSignature) {
      const head1Items = kirbGetDirectItems(head1);
      const head2Items = kirbGetDirectItems(head2);
      const total = Math.min(head1Items.length, head2Items.length);

      for (let i = 0; i < total; i++) {
        kirbBuildRectStep(head2Items[i], kirbGetIconHtml(head1Items[i]));
      }

      section.setAttribute("data-kirb-rect-signature", currentSignature);
    }

    kirbSyncActiveState(section);
    kirbBindByorHover(section);
  }

  function kirbInitRectByor() {
    kirbInjectByorRectStyle();
    document.querySelectorAll(".key-ideas-app .main-byor-section").forEach(kirbBuildByorSection);
  }

  document.addEventListener("DOMContentLoaded", kirbInitRectByor);
  window.addEventListener("load", kirbInitRectByor);
  window.addEventListener("pageshow", kirbInitRectByor);
  window.addEventListener("popstate", function () {
    setTimeout(kirbInitRectByor, 100);
    setTimeout(kirbInitRectByor, 400);
  });

  document.addEventListener(
    "click",
    function () {
      setTimeout(kirbInitRectByor, 80);
      setTimeout(kirbInitRectByor, 350);
    },
    true
  );

  setInterval(kirbInitRectByor, KIRB_SCAN_INTERVAL);

  document.querySelectorAll('a[href="#podium"]').forEach(link => {
    link.addEventListener("click", function(e) {
      e.preventDefault();
      if (window.PodiumWebChat) {
        window.PodiumWebChat.open();
      }
    });
  });

})();
